import updateEstimateField from '../Services/updateEstimateField';
import fetchEstimates from '../Services/fetchEstimates';

export default (id, field, value) => async (dispatch) => {

  await dispatch(updateEstimateField(id, field, value));

  await dispatch(fetchEstimates());
  
}